import { render } from "./divisionForm.vue?vue&type=template&id=04432401&scoped=true"
import script from "./divisionForm.vue?vue&type=script&lang=js"
export * from "./divisionForm.vue?vue&type=script&lang=js"

import "./divisionForm.vue?vue&type=style&index=0&id=04432401&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04432401"]])

export default __exports__